import { WORK_MANAGEMENT_PRODUCT_ID } from "constants/products";
import ProductSignUp from "segments/desktop/core-components/product-sign-up/product-sign-up";
import { componentStyles } from "segments/desktop/core-components/products-tabs/product-description/product-description.scss";
import { XS } from "constants/sizes";
import BulletIcon from "./bullet-icon";
import colors from "styles/colors";
import { WHITE_COLOR_NAME } from "styles/color-consts";

const ProductDescription = ({
  translate,
  productType = WORK_MANAGEMENT_PRODUCT_ID,
  features,
  ctaColor,
  featureColor,
  ctaText,
  isV2
}) => (
  <div className="product-description">
    <div className="divider" />
    <div className="features" style={isV2 ? { color: colors[WHITE_COLOR_NAME] } : {}}>
      <span className="features-title">{translate("productsSignUp.tabs.products.popularFeatures")}</span>
      <div className="features-container">
        {features?.map(({ feature }) => (
          <div className="feature">
            <BulletIcon color={isV2 ? colors[WHITE_COLOR_NAME] : featureColor} />
            <span>{feature}</span>
          </div>
        ))}
      </div>
    </div>
    <ProductSignUp buttonSize={XS} useCtaText ctaText={ctaText} buttonColor={ctaColor} productType={productType} />
    <style jsx>{componentStyles}</style>
  </div>
);

export default ProductDescription;
